import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Resource from "../../../Resource";
import PropTypes from "prop-types";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Section from '../../../Server/Section';

class ModalSectionConsumptions extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.state = {
            grid: {
                // defaultColDef: {
                //     floatingFilter: false
                // },
                columnDefs: [{
                    field: 'patientFileCode',
                    headerName: 'شماره پرونده',
                    headerTooltip: 'شماره پرونده بیمار',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'patientFirstName',
                    headerName: 'نام',
                    headerTooltip: 'نام بیمار'
                }, {
                    field: 'patientLastName',
                    headerName: 'نام خانوادگی',
                    headerTooltip: 'نام خانوادگی بیمار'
                }, {
                    field: 'patientBloodGroupStr',
                    headerName: 'BGRh بیمار',
                    headerTooltip: 'BGRh بیمار',
                    cellClass: 'green',
                    cellRenderer: row => row.data.patientBloodGroupStr || '-'
                }, {
                    field: 'patientNationalCode',
                    headerName: 'کد‌ملی',
                    headerTooltip: 'کد‌ملی بیمار'
                }, {
                    field: 'patientBirthDate',
                    headerName: 'تاریخ تولد',
                    headerTooltip: 'تاریخ تولد بیمار'
                }, {
                    field: 'sectionStr',
                    headerName: 'نام بخش',
                    headerTooltip: 'نام بخش'
                }, {
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    cellClass: 'green',
                    cellRenderer: row => row.data.productBloodGroupStr || '-'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده',
                    cellRenderer: row => row.data.productTypeStr || '-'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان درخواست',
                    headerTooltip: 'زمان درخواست',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'statusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.statusId === 40 && <GridState theme={'blue'}>{row.data.statusStr}</GridState>} {/*تحویل بخش داده شده*/}
                            {row.data.statusId === 41 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>} {/*عودت شده به بانک خون*/}
                            {row.data.statusId === 42 && <GridState theme={'red'}>{row.data.statusStr}</GridState>} {/*عارضه داده*/}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {![41, 42].includes(row.data.statusId) && <GridButton type={"button"} theme={'select'} title={'انتخاب'} onClick={this.select.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'انتخاب فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CLICKER.BLACK}" alt="">`,
                            action: this.select.bind(this, params.node.data),
                            disabled: [41, 42].includes(params.node.data.statusId)
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre'}>نشان دهنده گروه خونی بیمار / فرآورده می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'blue'}>تحویل داده شده به بخش</GridState> فرآورده‌ تحویل بخش داده شده است.</p>
                                <p><GridState theme={'yellow'}>عودت شده به بانک خون</GridState> فرآورده از بخش عودت داده شده است.</p>
                                <p><GridState theme={'red'}>عارضه داده</GridState> عارضه فرآورده ثبت گردیده است.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'select'} title={'انتخاب'}/> برای انتخاب رکورد مورد نظر و ادامه فرآیند از این طریق اقدام نمایید.</p>
                            </div>
                        </div>
                    </div>;
                },
                onRowDoubleClicked: row => this.select(row.data)
            },
            rowData: [],
            selectedRows: [],
            gridContext: null,
            resolve: _ => null,
            reject: _ => null
        };

        this.ref = {
            grid: React.createRef(),
            modal: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalSectionConsumptions'}
                   size={'wide'}
                   title={'فرآورده‌های مصرفی بخش'}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <Group className={'ModalSectionConsumptions-group fb-20'}>
                        <Grid refer={this.ref.grid} id={'sectionConsumptions'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        Section.consumptionList()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    close() {
        this.ref.modal.current.close();

        // فراخوانی reject ممکنه بعد از resolve اتفاق بیافته که مهم نیست مطمدنا resolve رو قبلش کال می کنم مشکلی چیش نمیاد
        this.state.reject();

        this.props.onClose();
    }

    open(data, action) {
        return new Promise((resolve, reject) => {
            this.ref.modal.current.open();

            this.setState({action, resolve, reject});
        });
    }

    select(row) {
        this.state.resolve(row);

        this.close();
    };
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalSectionConsumptions);